import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NgrxRouterService } from './ngrx-router.service';

@Injectable({ providedIn: 'root' })
export class ZefNgrxRouterGuard  {

  #ngrxRouterService = inject(NgrxRouterService);

  canActivate(route: ActivatedRouteSnapshot) {
    if ((route.data as any).key && route.params['id']) {
      this.#ngrxRouterService.setId((route.data as any).key, route.params['id']);
    }
    return true;
  }

  canDeactivate(_: any, route: ActivatedRouteSnapshot) {
    if ((route.data as any).key && route.params['id']) {
      this.#ngrxRouterService.resetId((route.data as any).key);
    }

    return true;
  }
}
